import Client from 'shopify-buy';

const client = Client.buildClient({
  domain: 'dvlpr.myshopify.com',
  storefrontAccessToken: 'fc96febb64bb9e6f4cfe5924af45263d',
});

export default client;
